export const statsigIdentifer = 'client-8RtS7QBg0bwU7M1tLxxBAvqgNeH0ThQAwHRqzUdqKLD';
